import React from "react";

const License = () => {
  return (
    <div className="mt-5 flex h-full w-full flex-col gap-5">
      <div className="flex h-full w-full flex-col rounded-[20px] bg-white bg-clip-border p-4 shadow-3xl shadow-shadow-500 dark:!bg-navy-800 dark:text-white dark:shadow-none">
        <h4 className="px-2 text-xl font-bold text-navy-700 dark:text-white">
          License
        </h4>
        <div className="mt-4 px-2 text-gray-600 dark:text-gray-300">
          {/* Add your license content here */}
          <p>


        <h2>END USER LICENSE AGREEMENT (EULA) AND TERMS OF SERVICE</h2>


<h3>Platform: Hypertrace.io</h3>

<h4>Provider: Terrasolis Technologies Private Limited</h4>


This End User License Agreement ("Agreement") is a legally binding contract between you (the "User") and Terrasolis Technologies Private Limited ("Terrasolis"). By accessing, logging into, or using the Hypertrace.io web portal and associated mobile applications (collectively, the "Platform"), you agree to be bound by the terms and conditions outlined below.

If you do not agree to these terms, you are prohibited from accessing or using the Platform.


1. License Grant & Permitted Use
Terrasolis grants the User a limited, revocable, non-exclusive, and non-transferable license to access and use the Platform strictly for the internal monitoring, control, and notification management of approved IoT tracking devices within the User's authorized fleet. This license is tied to an active, paid subscription and is subject to the terms of the overarching service agreement between Terrasolis and the User's organization.


2. Account Security & User Responsibilities
Access to the Platform is granted on an individual, authenticated basis. The User agrees to the following strict security protocols:

Credential Protection: Handover, sharing, or unauthorized distribution of login credentials, passwords, or authentication links to any third party or unauthorized colleague is strictly prohibited.

Session Security: The User shall never leave an active session unattended. The logged-in User assumes full responsibility for all actions taken under their account and is strictly required to log out of the Platform upon completing their tasks.

Internal Compliance: Users are mandated to consult with their organization’s designated Super Admin to understand and comply with any internal company policies, operational guidelines, or specific access restrictions applicable to their account tier.

Confidentiality: The User must maintain absolute secrecy regarding the data, interface, and operational workflows visible on the Platform.


3. Strict Prohibitions & Acceptable Use Policy
The Platform is a proprietary, closed-loop system. Under no circumstances shall the User engage in any of the following activities:

Reselling & Commercial Exploitation: Reselling, sub-licensing, or offering the Platform’s services, data, or interface to external third parties without explicit, written contractual agreement from Terrasolis.

Unauthorized Integration: Attempting to integrate the Platform, its data feeds, or its interface with external software, third-party ERPs, or other tracking systems without prior authorization and official API provisioning from Terrasolis.

Scraping & AI Usage: Using automated scripts, bots, spiders, or Artificial Intelligence (AI) tools to scrape, sweep, extract, or mine data from the Platform.

Reverse Engineering & Copying: Decompiling, reverse engineering, disassembling, or copying the software architecture, front-end design, or underlying business logic.

Derivative Works & Prompts: Utilizing the Platform’s interface, outputs, or features to document system requirements, generate training prompts for AI models, or replicate the service for alternative commercial use.


4. System Integrity & Security Boundaries
Terrasolis employs rigorous security measures to protect the integrity of the IoT ecosystem. The User is strictly prohibited from:

Hacking & Disruption: Attempting to probe, scan, test the vulnerability of, or breach the security and authentication measures of the Platform or its connected IoT devices.

Background Data Retrieval: Attempting to access, intercept, or retrieve background system parameters, including but not limited to API keys, authentication tokens, hidden server endpoints, or backend configurations.

Copyright Violation: Infringing upon any copyright, trademark, or intellectual property rights belonging to Terrasolis.


5. Intellectual Property Rights
All rights, title, and interest in and to the Platform, including hardware design, software code, circuit diagrams, component configurations, databases, UI/UX design, and brand assets (Hypertrace.io), remain the exclusive, globally protected Intellectual Property (IP) of Terrasolis Technologies Private Limited. This Agreement grants access rights only and does not transfer any ownership to the User or their organization.


6. IoT Data & Telemetry
As a paid IoT platform, Hypertrace.io continuously ingests telemetry, location data, and hardware diagnostics from connected devices. The User acknowledges that Terrasolis processes this data to provide the core services, maintain system health, and improve overarching platform capabilities.


7. Disclaimer of Warranties & Limitation of Liability
The Platform is provided on an "AS IS" and "AS AVAILABLE" basis. While Terrasolis ensures high availability and accuracy, we do not warrant that the platform will be entirely free from delays or interruptions caused by external cellular network outages, GNSS limitations, or third-party infrastructure failures. In no event shall Terrasolis be liable for any indirect, incidental, special, or consequential damages, or any loss of assets, revenue, or data arising from the use or inability to use the Platform.


8. Termination & Revocation
Terrasolis reserves the right to immediately suspend, throttle, or permanently terminate the User's access to the Platform, without prior notice, if the User is found to be in breach of any clauses within this Agreement, particularly those related to security, IP violation, or unauthorized system integrations.

</p>
        </div>
      </div>
    </div>
  );
};

export default License;